
const drawBrands = (brands, page) => {
    console.log('drawBrands', page);
    const container = document.querySelector('.brand-grid');
    const brandsPerPage = Number(container.getAttribute('data-elements'));
    const totalPages = Math.ceil(brands.length / brandsPerPage);
    const start = page * brandsPerPage;
    const end = start + brandsPerPage;
    console.log(totalPages, "inicio", start, "final", end);
    container.innerHTML = '';
    for (let i = start; i < end; i++) {
        if (brands[i]) {
            const brand = brands[i];
            const brandElement = document.createElement('a');
            brandElement.href = `/collections/${brand.handle}`;
            brandElement.classList.add('brand');
            brandElement.innerHTML = `
                <img src="${brand.image}" alt="${brand.title}" />
                <h4>${brand.title}</h4>
            `;
            container.appendChild(brandElement);
        }
    }
    drawPagination(brands, page, totalPages);
}

const drawPagination = (brands, page, totalPages) => {

    const paginationDiv = document.querySelector('.brand-pagination');
    paginationDiv.innerHTML = '';
    const previousButton = document.createElement('button');
    previousButton.innerHTML = '<';
    previousButton.addEventListener('click', () => drawBrands(brands, page - 1));
    if(page - 1 < 0 ){
      previousButton.setAttribute('disabled', 'disabled');
      previousButton.style.display = 'none';
    }
    paginationDiv.appendChild(previousButton);
    
    const numbersPaginationDiv = document.createElement('div');
    numbersPaginationDiv.classList.add('pagination-numbers');
    const startPage = Math.max(0, page - 1);
    const endPage = Math.min(totalPages - 1, startPage + 3);
    
    
    if(startPage > 0){
      const pageButton = document.createElement('button');
      pageButton.innerHTML = 1;
      pageButton.addEventListener('click', () => drawBrands(brands, 0));
      numbersPaginationDiv.appendChild(pageButton);
    }

    if(startPage > 1){
      const pageButton = document.createElement('button');
      pageButton.innerHTML = '...';
      pageButton.setAttribute('disabled', 'disabled');
      numbersPaginationDiv.appendChild(pageButton);
    }

    for (let i = startPage; i < endPage; i++) {      
      const pageButton = document.createElement('button');
      pageButton.innerHTML = i + 1;
      console.log(i)
      pageButton.addEventListener('click', () => drawBrands(brands, i));
      if (i === page) {
        pageButton.classList.add('active');
      }
      numbersPaginationDiv.appendChild(pageButton);
    }
    
    if(endPage < totalPages -1){
      const pageButton = document.createElement('button');
      pageButton.innerHTML = '...';
      pageButton.setAttribute('disabled', 'disabled');
      numbersPaginationDiv.appendChild(pageButton);
    }
    
    const pageButtonFinal = document.createElement('button');
    pageButtonFinal.innerHTML = totalPages;
    pageButtonFinal.addEventListener('click', () => drawBrands(brands, totalPages - 1));
    if (totalPages - 1 === page) {
      pageButtonFinal.classList.add('active');
    }
    numbersPaginationDiv.appendChild(pageButtonFinal);
    paginationDiv.appendChild(numbersPaginationDiv);
    
    const nextButton = document.createElement('button');
    nextButton.innerHTML = '>';
    nextButton.addEventListener('click', () => drawBrands(brands, page + 1));
    if(page + 1 == totalPages){
      nextButton.setAttribute('disabled', 'disabled');
      nextButton.style.display = 'none';
    }
    paginationDiv.appendChild(nextButton);
    

};


drawBrands(brands, 0);